var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5908 2.24138C12.62 2.10807 12.7542 2 12.8906 2H19.5615C19.6979 2 19.785 2.10807 19.7558 2.24138L18.3325 8.75862C18.3034 8.89193 18.1691 9 18.0327 9H11.3618C11.2254 9 11.1384 8.89193 11.1675 8.75862L12.5908 2.24138Z",
    fill: "#332FED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2383 2.24138C21.2674 2.10807 21.4016 2 21.538 2H32.6561C34.2936 2 35.3377 3.29683 34.9884 4.89655L31.0873 22.7586C31.0582 22.8919 30.9239 23 30.7875 23H24.466C24.3296 23 24.1954 23.1081 24.1662 23.2414L22.7429 29.7586C22.7138 29.8919 22.8008 30 22.9372 30H29.2587C29.3951 30 29.4821 30.1081 29.453 30.2414L28.0297 36.7586C28.0005 36.8919 27.8663 37 27.7299 37H21.059C20.9226 37 20.8355 36.8919 20.8647 36.7586L22.288 30.2414C22.3171 30.1081 22.2301 30 22.0937 30H15.4228C15.2864 30 15.1993 29.8919 15.2285 29.7586L16.6518 23.2414C16.6809 23.1081 16.8152 23 16.9516 23H23.6225C23.7589 23 23.8932 22.8919 23.9223 22.7586L26.6109 10.4483C26.7856 9.64842 26.2635 9 25.4448 9H20.0092C19.8728 9 19.7858 8.89193 19.8149 8.75862L21.2383 2.24138Z",
    fill: "#332FED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0455 10.4483C10.9091 10.4483 10.7748 10.5563 10.7457 10.6897L5.05224 36.7586C5.02312 36.8919 5.11014 37 5.24659 37H11.9175C12.0539 37 12.1881 36.8919 12.2172 36.7586L17.9107 10.6897C17.9398 10.5563 17.8528 10.4483 17.7164 10.4483H11.0455Z",
    fill: "#332FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.88d82f79bf6610cdde6e4b18cc46b6a6.svg";
export { ForwardRef as ReactComponent };